import { Field, FieldValues } from '../schema';

const coerce = (token: string): string | number | boolean => {
  const trimmed = token.trim();
  if (trimmed === 'true') return true;
  if (trimmed === 'false') return false;
  const n = Number(trimmed);
  if (!Number.isNaN(n) && trimmed !== '') return n;
  return trimmed.replace(/^['"]|['"]$/g, '');
};

const tokenize = (expr: string) => {
  const m = expr.match(/^\s*(\S+)\s+(==|!=|>=|<=|>|<|in)\s+(.+?)\s*$/);
  if (!m) return null;
  return { left: m[1], op: m[2], right: m[3] };
};

export const evaluateVisibleIf = (expr: string, values: FieldValues): boolean => {
  const parsed = tokenize(expr);
  if (!parsed) return true;
  const left = values[parsed.left];
  const right = coerce(parsed.right);
  switch (parsed.op) {
    case '==':
      return left === right;
    case '!=':
      return left !== right;
    case '>':
      return Number(left) > Number(right);
    case '<':
      return Number(left) < Number(right);
    case '>=':
      return Number(left) >= Number(right);
    case '<=':
      return Number(left) <= Number(right);
    case 'in':
      if (Array.isArray(right)) return right.includes(left as never);
      return String(right)
        .split(',')
        .map((s) => coerce(s))
        .includes(left as never);
    default:
      return true;
  }
};

// A field is read-only when statically disabled (`enabled: false`) or when its
// `enabled_if` expression evaluates false against the current form values.
export const isFieldEnabled = (field: Field, values: FieldValues): boolean => {
  if (field.enabled === false) return false;
  if (!field.enabled_if) return true;
  return evaluateVisibleIf(field.enabled_if, values);
};
